import { IconProps } from "components/src/components/Icon/types";

export function makeIcon(icon: string | IconProps) {
    if (typeof icon === "object" && "name" in icon && !!icon.name) return {size: "xs", ...icon};
    if (typeof icon === "string" && !!icon) return { name: icon, size: "xs" };
    return null;
}
